import { Injectable } from '@angular/core';
import { SigninService } from './signin.service';

@Injectable()
export class CommonService {
    appId = "";
    redirect_uri = "";
    constructor(private signinService: SigninService) { }
    
    getParam(paramName) {
        let paramValue = "", isFound = !1;
        if (window.location.search.indexOf("?") == 0 && window.location.search.indexOf("=") > 1) {
            let arrSource = decodeURIComponent(window.location.search).substring(1, window.location.search.length).split("&"), i = 0;
            while (i < arrSource.length && !isFound) {
                arrSource[i].indexOf("=") > 0 && arrSource[i].split("=")[0].toLowerCase() == paramName.toLowerCase()
                    && (paramValue = arrSource[i].split("=")[1], isFound = !0),
                    i++;
            }
        }
        return paramValue == "" && (paramValue = null), paramValue
    }

    oAuth() {
        return this.signinService.getWechatSettings();
    }
}


// WEBPACK FOOTER //
// ./src/services/common.service.ts